module.exports = __webpack_public_path__ + "img/lock-filled-grey.d5d9988b.svg";